export const CURRENCY_ACTION_TYPES = {
    SET_CURRENCY: 'currency/SET_CURRENCY'
};